const unsubscribeMapper = require('./atm/unsubscribe-mapper');

function UnsubscribeEdmService(restangular, atm) {
    this._api = restangular.one('shopper');
    this.atm = atm;
    this.restangular = restangular;
}

UnsubscribeEdmService.prototype.unsubscribeEDM = function (shopperid, checksum, documentid) {
    return this._api.one('communicationPreferences').get({ shopperId: shopperid, checksum, documentId: documentid });
};

UnsubscribeEdmService.prototype.unsubscribeEDMConfirmation = function (unsubscribeData) {
    return this._api.one('communicationPreferences').doPOST(unsubscribeData).then((response) => {
        if (response.Success) {
            const atmData = { preferences: this.restangular.stripRestangular(unsubscribeData) };
            this.atm.push(atmData, unsubscribeMapper);
        }
        return response;
    });
};

module.exports = UnsubscribeEdmService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/unsubscribeedm/unsubscribe-edm-service.js
 **/